import { defineStore } from "pinia";
import payrollService from "../../service/payroll/payroll.service";

import {
  Create,
  Update,
  UpdateSettings,
} from "../../service/payroll/interface/payroll.interface";

interface State {}
const payrollStore = defineStore("payroll", {
  state: (): State => ({}),
  actions: {
    async index(organisationId: number, scheduledDate: string | null, status: string | null, omitStatus: string | null, pageSize: number,pageNumber: number): Promise<any> {
      try {
        const response = await payrollService.get(organisationId, scheduledDate, status, omitStatus, pageSize, pageNumber);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async indexRecurring(organisationId: number, pageSize: number = 10, pageNumber: number = 1): Promise<any> {
  try {
    const response = await payrollService.getRecurring(organisationId, pageSize, pageNumber);
    if (response.data) {
      return await Promise.resolve(response);
    } else if (response.response) {
      return await Promise.reject(response.response);
    } else {
      return await Promise.reject(response.message);
    }
  } catch (error: any) {
    return await Promise.reject(error);
  }
},
    async deleteMany(data:string[]): Promise<any> {
      try {
        const response = await payrollService.deleteMany(data);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async retryPayment(id: string, data: any): Promise<any> {
      try {
        const response = await payrollService.retryPayment(id, data);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    // async initiate(department: any): Promise<any> {
    //   try {
    //     const response = await payrollService.initiate(department);
    //     if (response.data) {
    //       return await Promise.resolve(response);
    //     } else if (response.response) {
    //       return await Promise.reject(response.response);
    //     } else {
    //       return await Promise.reject(response.message);
    //     }
    //   } catch (error: any) {
    //     return await Promise.reject(error);
    //   }
    // },
    async initiate(organisationId: number, pageSize: number, pageNumber: number): Promise<any> {
      try {
        const response = await payrollService.initiate(organisationId, pageSize, pageNumber);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },

    async fetchEmployeePayroll(organisationId: number, employeeId: number, pageSize: number = 10, pageNumber: number = 1): Promise<any> {
      try {
        const response = await payrollService.getEmployeePayroll(organisationId, employeeId, pageSize, pageNumber);
        if (response.data) {
          const transformedData = { ...response.data };
          if (transformedData.data?.pageItems) {
            transformedData.data.pageItems = transformedData.data.pageItems.map((item: any) => ({
              ...item,
              bonus: item.bonusAmount !== undefined ? {
                amount: item.bonusAmount || 0,
                reason: item.bonusReason || ""
              } : item.bonus,
              deduction: item.deductionAmount !== undefined ? {
                amount: item.deductionAmount || 0,
                reason: item.deductionReason || ""
              } : item.deduction,
            }));
          }
          return transformedData;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        console.error("Error fetching payroll:", error);
        throw error;
      }
    },    

    async getPayrollHistory(userId: number, transactionMonth?: number, transactionYear?: number, pageSize: number = 10, pageNumber: number = 1): Promise<any> {
      try {
          const response = await payrollService.getPayrollHistory(userId, transactionMonth, transactionYear, pageSize, pageNumber);
          console.log('Payroll History:', response);

          if (response.data) {
              const transformedResponse = { ...response };
              if (transformedResponse.data?.data?.pageItems) {
                transformedResponse.data.data.pageItems = transformedResponse.data.data.pageItems.map((item: any) => ({
                  ...item,
                  employeeDetails: item.employeeDetails ? {
                    ...item.employeeDetails,
                    bonus: item.employeeDetails.bonusAmount !== undefined ? {
                      amount: item.employeeDetails.bonusAmount || 0,
                      reason: item.employeeDetails.bonusReason || ""
                    } : item.employeeDetails.bonus,
                    deduction: item.employeeDetails.deductionAmount !== undefined ? {
                      amount: item.employeeDetails.deductionAmount || 0,
                      reason: item.employeeDetails.deductionReason || ""
                    } : item.employeeDetails.deduction,
                  } : item.employeeDetails,
                }));
              }
              return await Promise.resolve(transformedResponse);
          } else if (response.response) {
              return await Promise.reject(response.response);
          } else {
              return await Promise.reject(response.message);
          }
      } catch (error: any) {
          return await Promise.reject(error);
      }
    },
    async generatePayslip(employeeId: number, organisationId: number, startDate: string, endDate: string): Promise<any> {
      try {
          const response = await payrollService.generatePayslip(employeeId, organisationId, startDate, endDate);
          if (response.data) {
              return Promise.resolve(response.data);
          } else if (response.response) {
              return Promise.reject(response.response);
          } else {
              return Promise.reject(response.message);
          }
      } catch (error: any) {
          return Promise.reject(error);
      }
  },  
  async getSalaryBreakdown(employeeId: number): Promise<any> {
    try {
        const response = await payrollService.getSalaryBreakdown(employeeId);
        if (response.data) {
            return Promise.resolve(response);
        } else if (response.response) {
            return Promise.reject(response.response);
        } else {
            return Promise.reject(response.message);
        }
    } catch (error: any) {
        return Promise.reject(error);
    }
},
    async draft(): Promise<any> {
      try {
        const response = await payrollService.draft();
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },

    async fetchDraftPayrollCount(organisationId: number): Promise<any> {
      try {
        const response = await payrollService.getDraftedPayrollCount(organisationId);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },    

    async downloadCsvTemplate(): Promise<void> {
      try {
        const response = await payrollService.generateCsvTemplate();
        if (response.data) {
          const blob = new Blob([response.data], { type: 'text/csv' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Payroll_Template.csv');
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else if (response.response) {
          throw response.response;
        } else {
          throw response.message;
        }
      } catch (error: any) {
        console.error('Error downloading CSV template:', error);
      }
    },

    async downloadPayrollCSV(params: {
      organisationId: number;
      payrollId: number;
    }): Promise<any> {
      try {
        const response = await payrollService.downloadPayrollCSV(params);
        if (response.data) {
          return { succeeded: true, data: response.data };
        } else if (response.response) {
          throw response.response;
        } else {
          throw response.message;
        }
      } catch (error: any) {
        console.error('Error downloading payroll CSV:', error);
        throw error;
      }
    },

    async downloadEmployeePayslip(params: {
      organisationId: number;
      payrollId: number;
      employeeId: string;
    }): Promise<any> {
      try {
        const response = await payrollService.downloadEmployeePayslip(params);
        if (response.data) {
          return { succeeded: true, data: response.data };
        } else if (response.response) {
          throw response.response;
        } else {
          throw response.message;
        }
      } catch (error: any) {
        console.error('Error downloading employee payslip:', error);
        throw error;
      }
    },

    async downloadAllPayslips(params: {
      organisationId: number;
      payrollId: number;
    }): Promise<any> {
      try {
        const response = await payrollService.downloadAllPayslips(params);
        if (response.data) {
          return { succeeded: true, data: response.data };
        } else if (response.response) {
          throw response.response;
        } else {
          throw response.message;
        }
      } catch (error: any) {
        console.error('Error downloading all payslips:', error);
        throw error;
      }
    },

    async getInternalPayslipList(payrollId: number): Promise<any> {
      try {
        const response = await payrollService.getInternalPayslipList(payrollId);
        if (response.data && response.data.succeeded) {
          return response.data;
        } else if (response.response) {
          throw response.response;
        } else {
          throw response.message;
        }
      } catch (error: any) {
        console.error('Error fetching internal payslip list:', error);
        throw error;
      }
    },    

    async importCsvFile(payload: { file: File; organisationId: number }): Promise<any> {
      try {
        const formData = new FormData();
        console.log("Payload being sent:", formData);
        formData.append('CsvFile', payload.file);
        formData.append('OrganisationId', payload.organisationId.toString()); 
        formData.forEach((value, key) => {
          console.log(`${key}:`, value);});
        const response = await payrollService.uploadCsv(formData);
        return response; 
      } catch (error: any) {
        console.error('Error importing CSV file:', error.response?.data);
        throw error; 
      }
    },

    async uploadPayrollCsv(csvFile: File, organisationId: number, scheduledMonth: string): Promise<void> {
      try {
        const response = await payrollService.uploadPayrollCsv(csvFile, organisationId, scheduledMonth);
        console.log('Payroll uploaded successfully:', response);
        return response; 
      } catch (error: any) {
        console.error('Error uploading payroll:', error.response ? error.response.data : error.message);
        //re-throw the error to propagate it
        throw error;
      }
    },
    
    async fetchOrganisationPayrollCount(organisationId: number, status: string | null, omitStatus: string | null = null): Promise<any> {
      try {
        const response = await payrollService.getOrganisationPayrollCount(organisationId, status, omitStatus);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },    

    async createPayroll(payload: {
      organisationId: number;
      employeesSalary: Array<{
        employeeId: number;
        grossPay: number;
        bonusAmount: number;
        bonusReason: string;
        deductionAmount: number;
        deductionReason: string;
        taxAmount: number;
        netPay: number;
      }>;
      scheduledMonth: string;
    }): Promise<any> {
      try {
        const response = await payrollService.createPayroll(payload);
        if (response.data && response.data.succeeded) {
          return response.data;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        console.error("Error creating payroll:", error);
        throw error;
      }
    },

    async updatePayroll(payload: {
      payrollId: number;
      organisationId: number;
      employeesSalary: Array<{
        lineItemId: number;
        bonusAmount: number;
        bonusReason: string;
        deductionAmount: number;
        deductionReason: string;
        taxAmount: number;
        netPay: number;
      }>;
      paytype: string;
      scheduledMonth: string;
    }): Promise<any> {
      try {
        console.log("Update payroll payload:", payload);
        const response = await payrollService.updatePayroll(payload);
        console.log("Update payroll response:", response);
        if (response.data && response.data.succeeded) {
          return response.data;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        console.error("Error updating payroll:", error);
        throw error;
      }
    },    

    async setupPayoutTime(payload: {
      organisationId: number;
      payrollId: number;
      sendTime: string;
    }): Promise<any> {
      try {
        const response = await payrollService.setupPayoutTime(payload);
        if (response.data && response.data.succeeded) {
          return response.data;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        console.error("Error setting up payout time:", error);
        throw error;
      }
    },   
    
   async updatePayrollFrequency(payPeriod: string): Promise<any> {
  try {
    const response = await payrollService.updatePayrollFrequency(payPeriod);
    console.log("Response from updatePayrollFrequency:", response);
    if (response.succeeded) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error) {
    console.error("Error updating frequency:", error);
    throw error;
  }
},

    
    async getPayroll(params: {
      organisationId: number;
      payrollId: number;
      pageSize?: number;
      pageNumber?: number;
    }): Promise<any> {
      try {
        const response = await payrollService.getPayroll(params);
        if (response.data && response.data.succeeded) {
          // Transform flat fields to nested objects for backward compatibility
          const transformedData = { ...response.data };
          if (transformedData.data?.pageItems?.employeeSalaries) {
            transformedData.data.pageItems.employeeSalaries = transformedData.data.pageItems.employeeSalaries.map((employee: any) => ({
              ...employee,
              bonus: employee.bonusAmount !== undefined ? {
                amount: employee.bonusAmount || 0,
                reason: employee.bonusReason || ""
              } : employee.bonus,
              deduction: employee.deductionAmount !== undefined ? {
                amount: employee.deductionAmount || 0,
                reason: employee.deductionReason || ""
              } : employee.deduction,
            }));
          }
          return transformedData;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        console.error("Error fetching payroll:", error);
        throw error;
      }
    },    

async toggleRecurringPayroll(payload: {
  payrollId: number;
  isRecurring: boolean;
}): Promise<any> {
  try {
    const response = await payrollService.toggleRecurringPayroll(
      payload.payrollId,
      payload.isRecurring
    );
    
    if (response.succeeded) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error) {
    console.error("Error toggling recurring payroll:", error);
    throw error;
  }
},

    async getPayrollTransaction(params: {
      payrollId: number;
      pageSize?: number;
      pageNumber?: number;
    }): Promise<any> {
      try {
        const response = await payrollService.getPayrollTransaction(params);
        if (response.data && response.data.succeeded) {
          const transformedData = { ...response.data };
          if (transformedData.data?.pageItems?.employeeTransactionResponses) {
            transformedData.data.pageItems.employeeTransactionResponses = transformedData.data.pageItems.employeeTransactionResponses.map((item: any) => ({
              ...item,
              employeeDetails: item.employeeDetails ? {
                ...item.employeeDetails,
                bonus: item.employeeDetails.bonusAmount !== undefined ? {
                  amount: item.employeeDetails.bonusAmount || 0,
                  reason: item.employeeDetails.bonusReason || ""
                } : item.employeeDetails.bonus,
                deduction: item.employeeDetails.deductionAmount !== undefined ? {
                  amount: item.employeeDetails.deductionAmount || 0,
                  reason: item.employeeDetails.deductionReason || ""
                } : item.employeeDetails.deduction,
              } : item.employeeDetails,
            }));
          }
          // Also transform payroll.lineItems and employeeSalaries if they exist
          if (transformedData.data?.pageItems?.payroll) {
            const payroll = transformedData.data.pageItems.payroll;
            if (payroll.lineItems) {
              payroll.lineItems = payroll.lineItems.map((item: any) => ({
                ...item,
                bonus: item.bonusAmount !== undefined ? {
                  amount: item.bonusAmount || 0,
                  reason: item.bonusReason || ""
                } : item.bonus,
                deduction: item.deductionAmount !== undefined ? {
                  amount: item.deductionAmount || 0,
                  reason: item.deductionReason || ""
                } : item.deduction,
              }));
            }
            if (payroll.employeeSalaries) {
              payroll.employeeSalaries = payroll.employeeSalaries.map((item: any) => ({
                ...item,
                bonus: item.bonusAmount !== undefined ? {
                  amount: item.bonusAmount || 0,
                  reason: item.bonusReason || ""
                } : item.bonus,
                deduction: item.deductionAmount !== undefined ? {
                  amount: item.deductionAmount || 0,
                  reason: item.deductionReason || ""
                } : item.deduction,
              }));
            }
            if (payroll.informalPayrolls) {
              payroll.informalPayrolls = payroll.informalPayrolls.map((item: any) => ({
                ...item,
                bonus: item.bonusAmount !== undefined ? {
                  amount: item.bonusAmount || 0,
                  reason: item.bonusReason || ""
                } : item.bonus,
                deduction: item.deductionAmount !== undefined ? {
                  amount: item.deductionAmount || 0,
                  reason: item.deductionReason || ""
                } : item.deduction,
              }));
            }
          }
          return transformedData;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        console.error("Error fetching payroll:", error);
        throw error;
      }
    },

    async approvePayroll(payrollId: number): Promise<any> {
      try {
        const response = await payrollService.approvePayroll(payrollId);
        if (response.data && response.data.succeeded) {
          return response.data;
        } else {
          throw new Error(response.message);
        }
      } catch (error: any) {
        // console.error("Error approving payroll:", error.response?.data?.message );
        throw error;
      }
    },

    async declinePayroll(payrollId: number, mainOrganisationUserId: number): Promise<any> {
      try {
        const response = await payrollService.declinePayroll(payrollId, mainOrganisationUserId);
        if (response.data && response.data.succeeded) {
          return response.data;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        console.error("Error declining payroll:", error);
        throw error;
      }
    },

    async submitPayroll(payload: { payrollId: number; organisationId: number }): Promise<any> {
      try {
        const response = await payrollService.submitPayroll(payload);
        if (response.data && response.data.succeeded) {
          return response.data;
        } else {
          throw new Error(response.message);
        }
      } catch (error: any) {
        console.error("Error submitting payroll:", error.response?.data?.message);
        throw error;
      }
    },   
    async savePayrollToDraft(payload: any): Promise<any> {
      try {
        const response = await payrollService.savePayrollToDraft(payload);
        if (response.data && response.data.succeeded) {
          return response.data;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        console.error("Error saving payroll to draft:", error);
        throw error;
      }
    },   
      
    async getOrganisationDraftedPayroll(params: {
      organisationId: number;
      draftedPayrollId?: number;
      pageSize?: number;
      pageNumber?: number;
    }): Promise<any> {
      try {
        const response = await payrollService.getOrganisationDraftedPayroll(params);
        if (response && response.succeeded) {
          return response;
        } else {
          throw new Error(response.message || "Failed to fetch drafted payroll.");
        }
      } catch (error) {
        console.error("Error in store fetching drafted payroll:", error);
        throw error;
      }
    },    
    async deleteDraftedPayroll(draftedPayrollId: number): Promise<any> {
      try {
        const response = await payrollService.deleteDraftedPayroll(draftedPayrollId);
        if (response && response.succeeded) {
          return response;
        } else {
          throw new Error(response.message || "Failed to delete drafted payroll.");
        }
      } catch (error) {
        console.error("Error in store deleting drafted payroll:", error);
        throw error;
      }
    },    
  
    async removeEmployee(payrollId: number, payrollLineItemId: number): Promise<any> {
      try {
              const response = await payrollService.removeEmployeeFromPayroll(payrollId, payrollLineItemId);
        if (response.data && response.data.succeeded) {
          return response.data;
        } else {
          throw new Error(response.message);
        }
      } catch (error) {
        console.error("Error removing employee:", error);
        throw error;
      }
    },

    // async getPayroll(organisationId: number, payrollId: number): Promise<any> {
    //   try {
    //     const response = await payrollService.getPayroll(organisationId, payrollId);
    //     if (response.data && response.data.succeeded) {
    //       return response.data;
    //     } else {
    //       throw new Error(response.message);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching payroll:", error);
    //     throw error;
    //   }
    // },
    async getSingle(id: string): Promise<any> {
      try {
        const response = await payrollService.getSingle(id);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async preview(department: any): Promise<any> {
      try {
        const response = await payrollService.preview(department);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async getSettings(): Promise<any> {
      try {
        const response = await payrollService.settings();
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async create(data: Create): Promise<any> {
      try {
        const response = await payrollService.create(data);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async update(data: Update, id: string): Promise<any> {
      try {
        const response = await payrollService.update(data, id);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async updateSettings(data: UpdateSettings): Promise<any> {
      try {
        const response = await payrollService.updateSettings(data);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
    async delete(id: string): Promise<any> {
      try {
        const response = await payrollService.delete(id);
        if (response.data) {
          return await Promise.resolve(response);
        } else if (response.response) {
          return await Promise.reject(response.response);
        } else {
          return await Promise.reject(response.message);
        }
      } catch (error: any) {
        return await Promise.reject(error);
      }
    },
  },
});

export default payrollStore;
